'use strict';
module.exports = require('./InlineMessage.vue');